/**
 * Type guard function that checks if a value is a number.
 * Returns true if the value is a number, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is a number, false otherwise
 *
 * @example
 * ```ts
 * import { IsNumber } from "@pdfking/tfunc"
 *
 * const num = 42;
 * const str = "42";
 *
 * if (IsNumber(num)) {
 *   console.log(num.toFixed(2)); // "42.00" (type narrowed to number)
 * }
 *
 * if (IsNumber(str)) {
 *   // This block won't execute
 * }
 *
 * // Use in filtering
 * const mixed = [1, "two", 3, "four"];
 * const numbers = mixed.filter(IsNumber); // [1, 3]
 * ```
 */
export const IsNumber = <T>(value: T): value is number & T =>
  typeof value === "number"
